// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CustomReportsRouteImport } from './routes/custom-reports'
import { Route as DeleteAccountRouteImport } from './routes/delete-account'
import { Route as DispatchRouteImport } from './routes/dispatch'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as HandsFreeRouteImport } from './routes/hands-free'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as ImprintRouteImport } from './routes/imprint'
import { Route as IncidentReportingRouteImport } from './routes/incident-reporting'
import { Route as InvoicingSoftwareRouteImport } from './routes/invoicing-software'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PatrolRouteImport } from './routes/patrol'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as RadioPttRouteImport } from './routes/radio-ptt'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SchedulingRouteImport } from './routes/scheduling'
import { Route as SecurityGuardManagementSoftwareRouteImport } from './routes/security-guard-management-software'
import { Route as SecurityGuardSoftwareRouteImport } from './routes/security-guard-software'
import { Route as SecurityIncidentReportingSoftwareRouteImport } from './routes/security-incident-reporting-software'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as StartRouteImport } from './routes/start'
import { Route as TemplatesRouteImport } from './routes/templates'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VoiceDarRouteImport } from './routes/voice-dar'
import { Route as AuthenticatedActivityRouteImport } from './routes/_authenticated/activity'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAiHelperRouteImport } from './routes/_authenticated/ai-helper'
import { Route as AuthenticatedAlertsRouteImport } from './routes/_authenticated/alerts'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedAssignmentsRouteImport } from './routes/_authenticated/assignments'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedClientsRouteImport } from './routes/_authenticated/clients'
import { Route as AuthenticatedContactsRouteImport } from './routes/_authenticated/contacts'
import { Route as AuthenticatedCredentialsRouteImport } from './routes/_authenticated/credentials'
import { Route as AuthenticatedDarRouteImport } from './routes/_authenticated/dar'
import { Route as AuthenticatedDashboardsRouteImport } from './routes/_authenticated/dashboards'
import { Route as AuthenticatedEquipmentRouteImport } from './routes/_authenticated/equipment'
import { Route as AuthenticatedEquipmentAdminRouteImport } from './routes/_authenticated/equipment-admin'
import { Route as AuthenticatedExportsRouteImport } from './routes/_authenticated/exports'
import { Route as AuthenticatedGeofencesRouteImport } from './routes/_authenticated/geofences'
import { Route as AuthenticatedGuardToursRouteImport } from './routes/_authenticated/guard-tours'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedIncidentsRouteImport } from './routes/_authenticated/incidents'
import { Route as AuthenticatedInvoicingRouteImport } from './routes/_authenticated/invoicing'
import { Route as AuthenticatedManagerRouteImport } from './routes/_authenticated/manager'
import { Route as AuthenticatedMessagesRouteImport } from './routes/_authenticated/messages'
import { Route as AuthenticatedModulesRouteImport } from './routes/_authenticated/modules'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedOperationsRouteImport } from './routes/_authenticated/operations'
import { Route as AuthenticatedPatrolsRouteImport } from './routes/_authenticated/patrols'
import { Route as AuthenticatedPortalRouteImport } from './routes/_authenticated/portal'
import { Route as AuthenticatedPostOrdersRouteImport } from './routes/_authenticated/post-orders'
import { Route as AuthenticatedRadioRouteImport } from './routes/_authenticated/radio'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedReviewRouteImport } from './routes/_authenticated/review'
import { Route as AuthenticatedScheduleRouteImport } from './routes/_authenticated/schedule'
import { Route as AuthenticatedSecurityRouteImport } from './routes/_authenticated/security'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedShiftReportsRouteImport } from './routes/_authenticated/shift-reports'
import { Route as AuthenticatedSiteActivityRouteImport } from './routes/_authenticated/site-activity'
import { Route as AuthenticatedSitesRouteImport } from './routes/_authenticated/sites'
import { Route as AuthenticatedSocRouteImport } from './routes/_authenticated/soc'
import { Route as AuthenticatedSosRouteImport } from './routes/_authenticated/sos'
import { Route as AuthenticatedSupervisorRouteImport } from './routes/_authenticated/supervisor'
import { Route as AuthenticatedTeamRouteImport } from './routes/_authenticated/team'
import { Route as AuthenticatedTimeClockRouteImport } from './routes/_authenticated/time-clock'
import { Route as AuthenticatedTrackingRouteImport } from './routes/_authenticated/tracking'
import { Route as AuthenticatedVehicleAdminRouteImport } from './routes/_authenticated/vehicle-admin'
import { Route as AuthenticatedVehicleInspectionRouteImport } from './routes/_authenticated/vehicle-inspection'
import { Route as AcceptContractTokenRouteImport } from './routes/accept-contract.$token'
import { Route as AcceptInviteTokenRouteImport } from './routes/accept-invite.$token'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as CheckoutReturnRouteImport } from './routes/checkout.return'
import { Route as LeadMagnetSecurityOpsChecklistRouteImport } from './routes/lead-magnet.security-ops-checklist'
import { Route as LeadMagnetThanksRouteImport } from './routes/lead-magnet.thanks'
import { Route as MarketingUnsubscribeRouteImport } from './routes/marketing.unsubscribe'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin.audit'
import { Route as AuthenticatedAdminContactRouteImport } from './routes/_authenticated/admin.contact'
import { Route as AuthenticatedAdminFunnelRouteImport } from './routes/_authenticated/admin.funnel'
import { Route as AuthenticatedAdminSignupsRouteImport } from './routes/_authenticated/admin.signups'
import { Route as AuthenticatedAdminTrafficRouteImport } from './routes/_authenticated/admin.traffic'
import { Route as AuthenticatedAdminWebVitalsRouteImport } from './routes/_authenticated/admin.web-vitals'
import { Route as AuthenticatedAnalyticsIndexRouteImport } from './routes/_authenticated/analytics.index'
import { Route as AuthenticatedAnalyticsActivityRouteImport } from './routes/_authenticated/analytics.activity'
import { Route as AuthenticatedAnalyticsHeatmapsRouteImport } from './routes/_authenticated/analytics.heatmaps'
import { Route as AuthenticatedAnalyticsIncidentsRouteImport } from './routes/_authenticated/analytics.incidents'
import { Route as AuthenticatedAnalyticsOfficersRouteImport } from './routes/_authenticated/analytics.officers'
import { Route as AuthenticatedConsoleDispatchRouteImport } from './routes/_authenticated/console.dispatch'
import { Route as AuthenticatedContractorIndexRouteImport } from './routes/_authenticated/contractor.index'
import { Route as AuthenticatedContractorPayPeriodsRouteImport } from './routes/_authenticated/contractor.pay-periods'
import { Route as AuthenticatedContractorScheduleRouteImport } from './routes/_authenticated/contractor.schedule'
import { Route as AuthenticatedContractorShiftClaimRouteImport } from './routes/_authenticated/contractor.shift-claim'
import { Route as AuthenticatedContractorsIndexRouteImport } from './routes/_authenticated/contractors.index'
import { Route as AuthenticatedContractorsPartnershipIdRouteImport } from './routes/_authenticated/contractors.$partnershipId'
import { Route as AuthenticatedCredentialsIndexRouteImport } from './routes/_authenticated/credentials.index'
import { Route as AuthenticatedCredentialsCredentialIdRouteImport } from './routes/_authenticated/credentials.$credentialId'
import { Route as AuthenticatedDarIndexRouteImport } from './routes/_authenticated/dar.index'
import { Route as AuthenticatedDarReportIdRouteImport } from './routes/_authenticated/dar.$reportId'
import { Route as AuthenticatedDarReviewRouteImport } from './routes/_authenticated/dar.review'
import { Route as AuthenticatedDashboardsIndexRouteImport } from './routes/_authenticated/dashboards.index'
import { Route as AuthenticatedDashboardsComplianceRouteImport } from './routes/_authenticated/dashboards.compliance'
import { Route as AuthenticatedDashboardsDispatchRouteImport } from './routes/_authenticated/dashboards.dispatch'
import { Route as AuthenticatedDashboardsIncidentsRouteImport } from './routes/_authenticated/dashboards.incidents'
import { Route as AuthenticatedDashboardsPulseRouteImport } from './routes/_authenticated/dashboards.pulse'
import { Route as AuthenticatedGuardToursIndexRouteImport } from './routes/_authenticated/guard-tours.index'
import { Route as AuthenticatedGuardToursTourIdRouteImport } from './routes/_authenticated/guard-tours.$tourId'
import { Route as AuthenticatedGuardToursActiveRouteImport } from './routes/_authenticated/guard-tours.active'
import { Route as AuthenticatedGuardToursScanRouteImport } from './routes/_authenticated/guard-tours.scan'
import { Route as AuthenticatedIncidentsIndexRouteImport } from './routes/_authenticated/incidents.index'
import { Route as AuthenticatedIncidentsIncidentIdRouteImport } from './routes/_authenticated/incidents.$incidentId'
import { Route as AuthenticatedIncidentsNewRouteImport } from './routes/_authenticated/incidents.new'
import { Route as AuthenticatedOperationsIndexRouteImport } from './routes/_authenticated/operations.index'
import { Route as AuthenticatedOperationsEvidenceRouteImport } from './routes/_authenticated/operations.evidence'
import { Route as AuthenticatedOperationsLiveRouteImport } from './routes/_authenticated/operations.live'
import { Route as AuthenticatedPatrolsIndexRouteImport } from './routes/_authenticated/patrols.index'
import { Route as AuthenticatedPatrolsPatrolIdRouteImport } from './routes/_authenticated/patrols.$patrolId'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports.index'
import { Route as AuthenticatedReportsCriticalRouteImport } from './routes/_authenticated/reports.critical'
import { Route as AuthenticatedReportsFollowUpRouteImport } from './routes/_authenticated/reports.follow-up'
import { Route as AuthenticatedReportsIncidentRouteImport } from './routes/_authenticated/reports.incident'
import { Route as AuthenticatedReportsNewRouteImport } from './routes/_authenticated/reports.new'
import { Route as AuthenticatedReportsTasksRouteImport } from './routes/_authenticated/reports.tasks'
import { Route as AuthenticatedReportsTemplatesRouteImport } from './routes/_authenticated/reports.templates'
import { Route as AuthenticatedReviewIndexRouteImport } from './routes/_authenticated/review.index'
import { Route as AuthenticatedReviewGeofenceRouteImport } from './routes/_authenticated/review.geofence'
import { Route as AuthenticatedReviewPunchRequestsRouteImport } from './routes/_authenticated/review.punch-requests'
import { Route as AuthenticatedReviewReportsRouteImport } from './routes/_authenticated/review.reports'
import { Route as AuthenticatedReviewTimecardsRouteImport } from './routes/_authenticated/review.timecards'
import { Route as AuthenticatedReviewToursRouteImport } from './routes/_authenticated/review.tours'
import { Route as AuthenticatedScanTokenRouteImport } from './routes/_authenticated/scan.$token'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings.index'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings.account'
import { Route as AuthenticatedSettingsApiTokensRouteImport } from './routes/_authenticated/settings.api-tokens'
import { Route as AuthenticatedSettingsBrandingRouteImport } from './routes/_authenticated/settings.branding'
import { Route as AuthenticatedSettingsLocationPrivacyRouteImport } from './routes/_authenticated/settings.location-privacy'
import { Route as AuthenticatedSettingsNavigationRouteImport } from './routes/_authenticated/settings.navigation'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings.notifications'
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings.security'
import { Route as AuthenticatedSitesIndexRouteImport } from './routes/_authenticated/sites.index'
import { Route as AuthenticatedSitesSiteIdRouteImport } from './routes/_authenticated/sites.$siteId'
import { Route as AuthenticatedSitesNewRouteImport } from './routes/_authenticated/sites.new'
import { Route as AuthenticatedTrackingIndexRouteImport } from './routes/_authenticated/tracking.index'
import { Route as AuthenticatedTrackingShiftIdRouteImport } from './routes/_authenticated/tracking.$shiftId'
import { Route as AuthenticatedGuardToursRunsRunIdRouteImport } from './routes/_authenticated/guard-tours.runs.$runId'
import { Route as AuthenticatedIncidentsIncidentIdIndexRouteImport } from './routes/_authenticated/incidents.$incidentId.index'
import { Route as AuthenticatedIncidentsIncidentIdFollowUpRouteImport } from './routes/_authenticated/incidents.$incidentId.follow-up'
import { Route as AuthenticatedReportsNewIndexRouteImport } from './routes/_authenticated/reports.new.index'
import { Route as AuthenticatedReportsNewTypeRouteImport } from './routes/_authenticated/reports.new.$type'
import { Route as AuthenticatedReportsTemplatesIndexRouteImport } from './routes/_authenticated/reports.templates.index'
import { Route as AuthenticatedReportsTemplatesIdRouteImport } from './routes/_authenticated/reports.templates.$id'
import { Route as AuthenticatedReviewTimecardsIndexRouteImport } from './routes/_authenticated/review.timecards.index'
import { Route as AuthenticatedReviewTimecardsSiteIdRouteImport } from './routes/_authenticated/review.timecards.$siteId'
import { Route as AuthenticatedSitesSiteIdIndexRouteImport } from './routes/_authenticated/sites.$siteId.index'
import { Route as AuthenticatedSitesSiteIdCheckpointsRouteImport } from './routes/_authenticated/sites.$siteId.checkpoints'
import { Route as AuthenticatedSitesSiteIdEditRouteImport } from './routes/_authenticated/sites.$siteId.edit'
import { Route as AuthenticatedReportsTemplatesIdIndexRouteImport } from './routes/_authenticated/reports.templates.$id.index'
import { Route as AuthenticatedReportsTemplatesIdFillRouteImport } from './routes/_authenticated/reports.templates.$id.fill'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const CompareRoute = CompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CustomReportsRoute = CustomReportsRouteImport.update({
            id: '/custom-reports',path: '/custom-reports',getParentRoute: () => rootRouteImport
          })
const DeleteAccountRoute = DeleteAccountRouteImport.update({
            id: '/delete-account',path: '/delete-account',getParentRoute: () => rootRouteImport
          })
const DispatchRoute = DispatchRouteImport.update({
            id: '/dispatch',path: '/dispatch',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const HandsFreeRoute = HandsFreeRouteImport.update({
            id: '/hands-free',path: '/hands-free',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const ImprintRoute = ImprintRouteImport.update({
            id: '/imprint',path: '/imprint',getParentRoute: () => rootRouteImport
          })
const IncidentReportingRoute = IncidentReportingRouteImport.update({
            id: '/incident-reporting',path: '/incident-reporting',getParentRoute: () => rootRouteImport
          })
const InvoicingSoftwareRoute = InvoicingSoftwareRouteImport.update({
            id: '/invoicing-software',path: '/invoicing-software',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PatrolRoute = PatrolRouteImport.update({
            id: '/patrol',path: '/patrol',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const RadioPttRoute = RadioPttRouteImport.update({
            id: '/radio-ptt',path: '/radio-ptt',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SchedulingRoute = SchedulingRouteImport.update({
            id: '/scheduling',path: '/scheduling',getParentRoute: () => rootRouteImport
          })
const SecurityGuardManagementSoftwareRoute = SecurityGuardManagementSoftwareRouteImport.update({
            id: '/security-guard-management-software',path: '/security-guard-management-software',getParentRoute: () => rootRouteImport
          })
const SecurityGuardSoftwareRoute = SecurityGuardSoftwareRouteImport.update({
            id: '/security-guard-software',path: '/security-guard-software',getParentRoute: () => rootRouteImport
          })
const SecurityIncidentReportingSoftwareRoute = SecurityIncidentReportingSoftwareRouteImport.update({
            id: '/security-incident-reporting-software',path: '/security-incident-reporting-software',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const StartRoute = StartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => rootRouteImport
          })
const TemplatesRoute = TemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const VoiceDarRoute = VoiceDarRouteImport.update({
            id: '/voice-dar',path: '/voice-dar',getParentRoute: () => rootRouteImport
          })
const AuthenticatedActivityRoute = AuthenticatedActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAiHelperRoute = AuthenticatedAiHelperRouteImport.update({
            id: '/ai-helper',path: '/ai-helper',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAlertsRoute = AuthenticatedAlertsRouteImport.update({
            id: '/alerts',path: '/alerts',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAssignmentsRoute = AuthenticatedAssignmentsRouteImport.update({
            id: '/assignments',path: '/assignments',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedClientsRoute = AuthenticatedClientsRouteImport.update({
            id: '/clients',path: '/clients',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedContactsRoute = AuthenticatedContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCredentialsRoute = AuthenticatedCredentialsRouteImport.update({
            id: '/credentials',path: '/credentials',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDarRoute = AuthenticatedDarRouteImport.update({
            id: '/dar',path: '/dar',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardsRoute = AuthenticatedDashboardsRouteImport.update({
            id: '/dashboards',path: '/dashboards',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedEquipmentRoute = AuthenticatedEquipmentRouteImport.update({
            id: '/equipment',path: '/equipment',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedEquipmentAdminRoute = AuthenticatedEquipmentAdminRouteImport.update({
            id: '/equipment-admin',path: '/equipment-admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedExportsRoute = AuthenticatedExportsRouteImport.update({
            id: '/exports',path: '/exports',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedGeofencesRoute = AuthenticatedGeofencesRouteImport.update({
            id: '/geofences',path: '/geofences',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedGuardToursRoute = AuthenticatedGuardToursRouteImport.update({
            id: '/guard-tours',path: '/guard-tours',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedIncidentsRoute = AuthenticatedIncidentsRouteImport.update({
            id: '/incidents',path: '/incidents',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedInvoicingRoute = AuthenticatedInvoicingRouteImport.update({
            id: '/invoicing',path: '/invoicing',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedManagerRoute = AuthenticatedManagerRouteImport.update({
            id: '/manager',path: '/manager',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedMessagesRoute = AuthenticatedMessagesRouteImport.update({
            id: '/messages',path: '/messages',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedModulesRoute = AuthenticatedModulesRouteImport.update({
            id: '/modules',path: '/modules',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedNotificationsRoute = AuthenticatedNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedOperationsRoute = AuthenticatedOperationsRouteImport.update({
            id: '/operations',path: '/operations',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPatrolsRoute = AuthenticatedPatrolsRouteImport.update({
            id: '/patrols',path: '/patrols',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPortalRoute = AuthenticatedPortalRouteImport.update({
            id: '/portal',path: '/portal',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPostOrdersRoute = AuthenticatedPostOrdersRouteImport.update({
            id: '/post-orders',path: '/post-orders',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedRadioRoute = AuthenticatedRadioRouteImport.update({
            id: '/radio',path: '/radio',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedReviewRoute = AuthenticatedReviewRouteImport.update({
            id: '/review',path: '/review',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedScheduleRoute = AuthenticatedScheduleRouteImport.update({
            id: '/schedule',path: '/schedule',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSecurityRoute = AuthenticatedSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedShiftReportsRoute = AuthenticatedShiftReportsRouteImport.update({
            id: '/shift-reports',path: '/shift-reports',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSiteActivityRoute = AuthenticatedSiteActivityRouteImport.update({
            id: '/site-activity',path: '/site-activity',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSitesRoute = AuthenticatedSitesRouteImport.update({
            id: '/sites',path: '/sites',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSocRoute = AuthenticatedSocRouteImport.update({
            id: '/soc',path: '/soc',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSosRoute = AuthenticatedSosRouteImport.update({
            id: '/sos',path: '/sos',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSupervisorRoute = AuthenticatedSupervisorRouteImport.update({
            id: '/supervisor',path: '/supervisor',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTeamRoute = AuthenticatedTeamRouteImport.update({
            id: '/team',path: '/team',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTimeClockRoute = AuthenticatedTimeClockRouteImport.update({
            id: '/time-clock',path: '/time-clock',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTrackingRoute = AuthenticatedTrackingRouteImport.update({
            id: '/tracking',path: '/tracking',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedVehicleAdminRoute = AuthenticatedVehicleAdminRouteImport.update({
            id: '/vehicle-admin',path: '/vehicle-admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedVehicleInspectionRoute = AuthenticatedVehicleInspectionRouteImport.update({
            id: '/vehicle-inspection',path: '/vehicle-inspection',getParentRoute: () => AuthenticatedRoute
          })
const AcceptContractTokenRoute = AcceptContractTokenRouteImport.update({
            id: '/accept-contract/$token',path: '/accept-contract/$token',getParentRoute: () => rootRouteImport
          })
const AcceptInviteTokenRoute = AcceptInviteTokenRouteImport.update({
            id: '/accept-invite/$token',path: '/accept-invite/$token',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
            id: '/checkout/return',path: '/checkout/return',getParentRoute: () => rootRouteImport
          })
const LeadMagnetSecurityOpsChecklistRoute = LeadMagnetSecurityOpsChecklistRouteImport.update({
            id: '/lead-magnet/security-ops-checklist',path: '/lead-magnet/security-ops-checklist',getParentRoute: () => rootRouteImport
          })
const LeadMagnetThanksRoute = LeadMagnetThanksRouteImport.update({
            id: '/lead-magnet/thanks',path: '/lead-magnet/thanks',getParentRoute: () => rootRouteImport
          })
const MarketingUnsubscribeRoute = MarketingUnsubscribeRouteImport.update({
            id: '/marketing/unsubscribe',path: '/marketing/unsubscribe',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContactRoute = AuthenticatedAdminContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminFunnelRoute = AuthenticatedAdminFunnelRouteImport.update({
            id: '/funnel',path: '/funnel',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSignupsRoute = AuthenticatedAdminSignupsRouteImport.update({
            id: '/signups',path: '/signups',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminTrafficRoute = AuthenticatedAdminTrafficRouteImport.update({
            id: '/traffic',path: '/traffic',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminWebVitalsRoute = AuthenticatedAdminWebVitalsRouteImport.update({
            id: '/web-vitals',path: '/web-vitals',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAnalyticsIndexRoute = AuthenticatedAnalyticsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAnalyticsRoute
          })
const AuthenticatedAnalyticsActivityRoute = AuthenticatedAnalyticsActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => AuthenticatedAnalyticsRoute
          })
const AuthenticatedAnalyticsHeatmapsRoute = AuthenticatedAnalyticsHeatmapsRouteImport.update({
            id: '/heatmaps',path: '/heatmaps',getParentRoute: () => AuthenticatedAnalyticsRoute
          })
const AuthenticatedAnalyticsIncidentsRoute = AuthenticatedAnalyticsIncidentsRouteImport.update({
            id: '/incidents',path: '/incidents',getParentRoute: () => AuthenticatedAnalyticsRoute
          })
const AuthenticatedAnalyticsOfficersRoute = AuthenticatedAnalyticsOfficersRouteImport.update({
            id: '/officers',path: '/officers',getParentRoute: () => AuthenticatedAnalyticsRoute
          })
const AuthenticatedConsoleDispatchRoute = AuthenticatedConsoleDispatchRouteImport.update({
            id: '/console/dispatch',path: '/console/dispatch',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedContractorIndexRoute = AuthenticatedContractorIndexRouteImport.update({
            id: '/contractor/',path: '/contractor/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedContractorPayPeriodsRoute = AuthenticatedContractorPayPeriodsRouteImport.update({
            id: '/contractor/pay-periods',path: '/contractor/pay-periods',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedContractorScheduleRoute = AuthenticatedContractorScheduleRouteImport.update({
            id: '/contractor/schedule',path: '/contractor/schedule',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedContractorShiftClaimRoute = AuthenticatedContractorShiftClaimRouteImport.update({
            id: '/contractor/shift-claim',path: '/contractor/shift-claim',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedContractorsIndexRoute = AuthenticatedContractorsIndexRouteImport.update({
            id: '/contractors/',path: '/contractors/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedContractorsPartnershipIdRoute = AuthenticatedContractorsPartnershipIdRouteImport.update({
            id: '/contractors/$partnershipId',path: '/contractors/$partnershipId',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCredentialsIndexRoute = AuthenticatedCredentialsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedCredentialsRoute
          })
const AuthenticatedCredentialsCredentialIdRoute = AuthenticatedCredentialsCredentialIdRouteImport.update({
            id: '/$credentialId',path: '/$credentialId',getParentRoute: () => AuthenticatedCredentialsRoute
          })
const AuthenticatedDarIndexRoute = AuthenticatedDarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedDarRoute
          })
const AuthenticatedDarReportIdRoute = AuthenticatedDarReportIdRouteImport.update({
            id: '/$reportId',path: '/$reportId',getParentRoute: () => AuthenticatedDarRoute
          })
const AuthenticatedDarReviewRoute = AuthenticatedDarReviewRouteImport.update({
            id: '/review',path: '/review',getParentRoute: () => AuthenticatedDarRoute
          })
const AuthenticatedDashboardsIndexRoute = AuthenticatedDashboardsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedDashboardsRoute
          })
const AuthenticatedDashboardsComplianceRoute = AuthenticatedDashboardsComplianceRouteImport.update({
            id: '/compliance',path: '/compliance',getParentRoute: () => AuthenticatedDashboardsRoute
          })
const AuthenticatedDashboardsDispatchRoute = AuthenticatedDashboardsDispatchRouteImport.update({
            id: '/dispatch',path: '/dispatch',getParentRoute: () => AuthenticatedDashboardsRoute
          })
const AuthenticatedDashboardsIncidentsRoute = AuthenticatedDashboardsIncidentsRouteImport.update({
            id: '/incidents',path: '/incidents',getParentRoute: () => AuthenticatedDashboardsRoute
          })
const AuthenticatedDashboardsPulseRoute = AuthenticatedDashboardsPulseRouteImport.update({
            id: '/pulse',path: '/pulse',getParentRoute: () => AuthenticatedDashboardsRoute
          })
const AuthenticatedGuardToursIndexRoute = AuthenticatedGuardToursIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedGuardToursRoute
          })
const AuthenticatedGuardToursTourIdRoute = AuthenticatedGuardToursTourIdRouteImport.update({
            id: '/$tourId',path: '/$tourId',getParentRoute: () => AuthenticatedGuardToursRoute
          })
const AuthenticatedGuardToursActiveRoute = AuthenticatedGuardToursActiveRouteImport.update({
            id: '/active',path: '/active',getParentRoute: () => AuthenticatedGuardToursRoute
          })
const AuthenticatedGuardToursScanRoute = AuthenticatedGuardToursScanRouteImport.update({
            id: '/scan',path: '/scan',getParentRoute: () => AuthenticatedGuardToursRoute
          })
const AuthenticatedIncidentsIndexRoute = AuthenticatedIncidentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedIncidentsRoute
          })
const AuthenticatedIncidentsIncidentIdRoute = AuthenticatedIncidentsIncidentIdRouteImport.update({
            id: '/$incidentId',path: '/$incidentId',getParentRoute: () => AuthenticatedIncidentsRoute
          })
const AuthenticatedIncidentsNewRoute = AuthenticatedIncidentsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedIncidentsRoute
          })
const AuthenticatedOperationsIndexRoute = AuthenticatedOperationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedOperationsRoute
          })
const AuthenticatedOperationsEvidenceRoute = AuthenticatedOperationsEvidenceRouteImport.update({
            id: '/evidence',path: '/evidence',getParentRoute: () => AuthenticatedOperationsRoute
          })
const AuthenticatedOperationsLiveRoute = AuthenticatedOperationsLiveRouteImport.update({
            id: '/live',path: '/live',getParentRoute: () => AuthenticatedOperationsRoute
          })
const AuthenticatedPatrolsIndexRoute = AuthenticatedPatrolsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedPatrolsRoute
          })
const AuthenticatedPatrolsPatrolIdRoute = AuthenticatedPatrolsPatrolIdRouteImport.update({
            id: '/$patrolId',path: '/$patrolId',getParentRoute: () => AuthenticatedPatrolsRoute
          })
const AuthenticatedReportsIndexRoute = AuthenticatedReportsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedReportsRoute
          })
const AuthenticatedReportsCriticalRoute = AuthenticatedReportsCriticalRouteImport.update({
            id: '/critical',path: '/critical',getParentRoute: () => AuthenticatedReportsRoute
          })
const AuthenticatedReportsFollowUpRoute = AuthenticatedReportsFollowUpRouteImport.update({
            id: '/follow-up',path: '/follow-up',getParentRoute: () => AuthenticatedReportsRoute
          })
const AuthenticatedReportsIncidentRoute = AuthenticatedReportsIncidentRouteImport.update({
            id: '/incident',path: '/incident',getParentRoute: () => AuthenticatedReportsRoute
          })
const AuthenticatedReportsNewRoute = AuthenticatedReportsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedReportsRoute
          })
const AuthenticatedReportsTasksRoute = AuthenticatedReportsTasksRouteImport.update({
            id: '/tasks',path: '/tasks',getParentRoute: () => AuthenticatedReportsRoute
          })
const AuthenticatedReportsTemplatesRoute = AuthenticatedReportsTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => AuthenticatedReportsRoute
          })
const AuthenticatedReviewIndexRoute = AuthenticatedReviewIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedReviewRoute
          })
const AuthenticatedReviewGeofenceRoute = AuthenticatedReviewGeofenceRouteImport.update({
            id: '/geofence',path: '/geofence',getParentRoute: () => AuthenticatedReviewRoute
          })
const AuthenticatedReviewPunchRequestsRoute = AuthenticatedReviewPunchRequestsRouteImport.update({
            id: '/punch-requests',path: '/punch-requests',getParentRoute: () => AuthenticatedReviewRoute
          })
const AuthenticatedReviewReportsRoute = AuthenticatedReviewReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AuthenticatedReviewRoute
          })
const AuthenticatedReviewTimecardsRoute = AuthenticatedReviewTimecardsRouteImport.update({
            id: '/timecards',path: '/timecards',getParentRoute: () => AuthenticatedReviewRoute
          })
const AuthenticatedReviewToursRoute = AuthenticatedReviewToursRouteImport.update({
            id: '/tours',path: '/tours',getParentRoute: () => AuthenticatedReviewRoute
          })
const AuthenticatedScanTokenRoute = AuthenticatedScanTokenRouteImport.update({
            id: '/scan/$token',path: '/scan/$token',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsAccountRoute = AuthenticatedSettingsAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsApiTokensRoute = AuthenticatedSettingsApiTokensRouteImport.update({
            id: '/api-tokens',path: '/api-tokens',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsBrandingRoute = AuthenticatedSettingsBrandingRouteImport.update({
            id: '/branding',path: '/branding',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsLocationPrivacyRoute = AuthenticatedSettingsLocationPrivacyRouteImport.update({
            id: '/location-privacy',path: '/location-privacy',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsNavigationRoute = AuthenticatedSettingsNavigationRouteImport.update({
            id: '/navigation',path: '/navigation',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsNotificationsRoute = AuthenticatedSettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSettingsSecurityRoute = AuthenticatedSettingsSecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => AuthenticatedSettingsRoute
          })
const AuthenticatedSitesIndexRoute = AuthenticatedSitesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedSitesRoute
          })
const AuthenticatedSitesSiteIdRoute = AuthenticatedSitesSiteIdRouteImport.update({
            id: '/$siteId',path: '/$siteId',getParentRoute: () => AuthenticatedSitesRoute
          })
const AuthenticatedSitesNewRoute = AuthenticatedSitesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedSitesRoute
          })
const AuthenticatedTrackingIndexRoute = AuthenticatedTrackingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTrackingRoute
          })
const AuthenticatedTrackingShiftIdRoute = AuthenticatedTrackingShiftIdRouteImport.update({
            id: '/$shiftId',path: '/$shiftId',getParentRoute: () => AuthenticatedTrackingRoute
          })
const AuthenticatedGuardToursRunsRunIdRoute = AuthenticatedGuardToursRunsRunIdRouteImport.update({
            id: '/runs/$runId',path: '/runs/$runId',getParentRoute: () => AuthenticatedGuardToursRoute
          })
const AuthenticatedIncidentsIncidentIdIndexRoute = AuthenticatedIncidentsIncidentIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedIncidentsIncidentIdRoute
          })
const AuthenticatedIncidentsIncidentIdFollowUpRoute = AuthenticatedIncidentsIncidentIdFollowUpRouteImport.update({
            id: '/follow-up',path: '/follow-up',getParentRoute: () => AuthenticatedIncidentsIncidentIdRoute
          })
const AuthenticatedReportsNewIndexRoute = AuthenticatedReportsNewIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedReportsNewRoute
          })
const AuthenticatedReportsNewTypeRoute = AuthenticatedReportsNewTypeRouteImport.update({
            id: '/$type',path: '/$type',getParentRoute: () => AuthenticatedReportsNewRoute
          })
const AuthenticatedReportsTemplatesIndexRoute = AuthenticatedReportsTemplatesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedReportsTemplatesRoute
          })
const AuthenticatedReportsTemplatesIdRoute = AuthenticatedReportsTemplatesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedReportsTemplatesRoute
          })
const AuthenticatedReviewTimecardsIndexRoute = AuthenticatedReviewTimecardsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedReviewTimecardsRoute
          })
const AuthenticatedReviewTimecardsSiteIdRoute = AuthenticatedReviewTimecardsSiteIdRouteImport.update({
            id: '/$siteId',path: '/$siteId',getParentRoute: () => AuthenticatedReviewTimecardsRoute
          })
const AuthenticatedSitesSiteIdIndexRoute = AuthenticatedSitesSiteIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedSitesSiteIdRoute
          })
const AuthenticatedSitesSiteIdCheckpointsRoute = AuthenticatedSitesSiteIdCheckpointsRouteImport.update({
            id: '/checkpoints',path: '/checkpoints',getParentRoute: () => AuthenticatedSitesSiteIdRoute
          })
const AuthenticatedSitesSiteIdEditRoute = AuthenticatedSitesSiteIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => AuthenticatedSitesSiteIdRoute
          })
const AuthenticatedReportsTemplatesIdIndexRoute = AuthenticatedReportsTemplatesIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedReportsTemplatesIdRoute
          })
const AuthenticatedReportsTemplatesIdFillRoute = AuthenticatedReportsTemplatesIdFillRouteImport.update({
            id: '/fill',path: '/fill',getParentRoute: () => AuthenticatedReportsTemplatesIdRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,AuthenticatedAdminContactRoute: AuthenticatedAdminContactRoute,AuthenticatedAdminFunnelRoute: AuthenticatedAdminFunnelRoute,AuthenticatedAdminSignupsRoute: AuthenticatedAdminSignupsRoute,AuthenticatedAdminTrafficRoute: AuthenticatedAdminTrafficRoute,AuthenticatedAdminWebVitalsRoute: AuthenticatedAdminWebVitalsRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)




const AuthenticatedAnalyticsRouteChildren = {
  AuthenticatedAnalyticsActivityRoute: AuthenticatedAnalyticsActivityRoute,AuthenticatedAnalyticsHeatmapsRoute: AuthenticatedAnalyticsHeatmapsRoute,AuthenticatedAnalyticsIncidentsRoute: AuthenticatedAnalyticsIncidentsRoute,AuthenticatedAnalyticsOfficersRoute: AuthenticatedAnalyticsOfficersRoute,AuthenticatedAnalyticsIndexRoute: AuthenticatedAnalyticsIndexRoute
}

const AuthenticatedAnalyticsRouteWithChildren = AuthenticatedAnalyticsRoute._addFileChildren(AuthenticatedAnalyticsRouteChildren)




const AuthenticatedCredentialsRouteChildren = {
  AuthenticatedCredentialsCredentialIdRoute: AuthenticatedCredentialsCredentialIdRoute,AuthenticatedCredentialsIndexRoute: AuthenticatedCredentialsIndexRoute
}

const AuthenticatedCredentialsRouteWithChildren = AuthenticatedCredentialsRoute._addFileChildren(AuthenticatedCredentialsRouteChildren)




const AuthenticatedDarRouteChildren = {
  AuthenticatedDarReportIdRoute: AuthenticatedDarReportIdRoute,AuthenticatedDarReviewRoute: AuthenticatedDarReviewRoute,AuthenticatedDarIndexRoute: AuthenticatedDarIndexRoute
}

const AuthenticatedDarRouteWithChildren = AuthenticatedDarRoute._addFileChildren(AuthenticatedDarRouteChildren)




const AuthenticatedDashboardsRouteChildren = {
  AuthenticatedDashboardsComplianceRoute: AuthenticatedDashboardsComplianceRoute,AuthenticatedDashboardsDispatchRoute: AuthenticatedDashboardsDispatchRoute,AuthenticatedDashboardsIncidentsRoute: AuthenticatedDashboardsIncidentsRoute,AuthenticatedDashboardsPulseRoute: AuthenticatedDashboardsPulseRoute,AuthenticatedDashboardsIndexRoute: AuthenticatedDashboardsIndexRoute
}

const AuthenticatedDashboardsRouteWithChildren = AuthenticatedDashboardsRoute._addFileChildren(AuthenticatedDashboardsRouteChildren)




const AuthenticatedGuardToursRouteChildren = {
  AuthenticatedGuardToursTourIdRoute: AuthenticatedGuardToursTourIdRoute,AuthenticatedGuardToursActiveRoute: AuthenticatedGuardToursActiveRoute,AuthenticatedGuardToursScanRoute: AuthenticatedGuardToursScanRoute,AuthenticatedGuardToursIndexRoute: AuthenticatedGuardToursIndexRoute,AuthenticatedGuardToursRunsRunIdRoute: AuthenticatedGuardToursRunsRunIdRoute
}

const AuthenticatedGuardToursRouteWithChildren = AuthenticatedGuardToursRoute._addFileChildren(AuthenticatedGuardToursRouteChildren)




const AuthenticatedIncidentsIncidentIdRouteChildren = {
  AuthenticatedIncidentsIncidentIdFollowUpRoute: AuthenticatedIncidentsIncidentIdFollowUpRoute,AuthenticatedIncidentsIncidentIdIndexRoute: AuthenticatedIncidentsIncidentIdIndexRoute
}

const AuthenticatedIncidentsIncidentIdRouteWithChildren = AuthenticatedIncidentsIncidentIdRoute._addFileChildren(AuthenticatedIncidentsIncidentIdRouteChildren)



const AuthenticatedIncidentsRouteChildren = {
  AuthenticatedIncidentsIncidentIdRoute: AuthenticatedIncidentsIncidentIdRouteWithChildren,AuthenticatedIncidentsNewRoute: AuthenticatedIncidentsNewRoute,AuthenticatedIncidentsIndexRoute: AuthenticatedIncidentsIndexRoute
}

const AuthenticatedIncidentsRouteWithChildren = AuthenticatedIncidentsRoute._addFileChildren(AuthenticatedIncidentsRouteChildren)




const AuthenticatedOperationsRouteChildren = {
  AuthenticatedOperationsEvidenceRoute: AuthenticatedOperationsEvidenceRoute,AuthenticatedOperationsLiveRoute: AuthenticatedOperationsLiveRoute,AuthenticatedOperationsIndexRoute: AuthenticatedOperationsIndexRoute
}

const AuthenticatedOperationsRouteWithChildren = AuthenticatedOperationsRoute._addFileChildren(AuthenticatedOperationsRouteChildren)




const AuthenticatedPatrolsRouteChildren = {
  AuthenticatedPatrolsPatrolIdRoute: AuthenticatedPatrolsPatrolIdRoute,AuthenticatedPatrolsIndexRoute: AuthenticatedPatrolsIndexRoute
}

const AuthenticatedPatrolsRouteWithChildren = AuthenticatedPatrolsRoute._addFileChildren(AuthenticatedPatrolsRouteChildren)




const AuthenticatedReportsNewRouteChildren = {
  AuthenticatedReportsNewTypeRoute: AuthenticatedReportsNewTypeRoute,AuthenticatedReportsNewIndexRoute: AuthenticatedReportsNewIndexRoute
}

const AuthenticatedReportsNewRouteWithChildren = AuthenticatedReportsNewRoute._addFileChildren(AuthenticatedReportsNewRouteChildren)




const AuthenticatedReportsTemplatesIdRouteChildren = {
  AuthenticatedReportsTemplatesIdFillRoute: AuthenticatedReportsTemplatesIdFillRoute,AuthenticatedReportsTemplatesIdIndexRoute: AuthenticatedReportsTemplatesIdIndexRoute
}

const AuthenticatedReportsTemplatesIdRouteWithChildren = AuthenticatedReportsTemplatesIdRoute._addFileChildren(AuthenticatedReportsTemplatesIdRouteChildren)



const AuthenticatedReportsTemplatesRouteChildren = {
  AuthenticatedReportsTemplatesIdRoute: AuthenticatedReportsTemplatesIdRouteWithChildren,AuthenticatedReportsTemplatesIndexRoute: AuthenticatedReportsTemplatesIndexRoute
}

const AuthenticatedReportsTemplatesRouteWithChildren = AuthenticatedReportsTemplatesRoute._addFileChildren(AuthenticatedReportsTemplatesRouteChildren)



const AuthenticatedReportsRouteChildren = {
  AuthenticatedReportsCriticalRoute: AuthenticatedReportsCriticalRoute,AuthenticatedReportsFollowUpRoute: AuthenticatedReportsFollowUpRoute,AuthenticatedReportsIncidentRoute: AuthenticatedReportsIncidentRoute,AuthenticatedReportsNewRoute: AuthenticatedReportsNewRouteWithChildren,AuthenticatedReportsTasksRoute: AuthenticatedReportsTasksRoute,AuthenticatedReportsTemplatesRoute: AuthenticatedReportsTemplatesRouteWithChildren,AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute
}

const AuthenticatedReportsRouteWithChildren = AuthenticatedReportsRoute._addFileChildren(AuthenticatedReportsRouteChildren)




const AuthenticatedReviewTimecardsRouteChildren = {
  AuthenticatedReviewTimecardsSiteIdRoute: AuthenticatedReviewTimecardsSiteIdRoute,AuthenticatedReviewTimecardsIndexRoute: AuthenticatedReviewTimecardsIndexRoute
}

const AuthenticatedReviewTimecardsRouteWithChildren = AuthenticatedReviewTimecardsRoute._addFileChildren(AuthenticatedReviewTimecardsRouteChildren)



const AuthenticatedReviewRouteChildren = {
  AuthenticatedReviewGeofenceRoute: AuthenticatedReviewGeofenceRoute,AuthenticatedReviewPunchRequestsRoute: AuthenticatedReviewPunchRequestsRoute,AuthenticatedReviewReportsRoute: AuthenticatedReviewReportsRoute,AuthenticatedReviewTimecardsRoute: AuthenticatedReviewTimecardsRouteWithChildren,AuthenticatedReviewToursRoute: AuthenticatedReviewToursRoute,AuthenticatedReviewIndexRoute: AuthenticatedReviewIndexRoute
}

const AuthenticatedReviewRouteWithChildren = AuthenticatedReviewRoute._addFileChildren(AuthenticatedReviewRouteChildren)




const AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,AuthenticatedSettingsApiTokensRoute: AuthenticatedSettingsApiTokensRoute,AuthenticatedSettingsBrandingRoute: AuthenticatedSettingsBrandingRoute,AuthenticatedSettingsLocationPrivacyRoute: AuthenticatedSettingsLocationPrivacyRoute,AuthenticatedSettingsNavigationRoute: AuthenticatedSettingsNavigationRoute,AuthenticatedSettingsNotificationsRoute: AuthenticatedSettingsNotificationsRoute,AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteWithChildren = AuthenticatedSettingsRoute._addFileChildren(AuthenticatedSettingsRouteChildren)




const AuthenticatedSitesSiteIdRouteChildren = {
  AuthenticatedSitesSiteIdCheckpointsRoute: AuthenticatedSitesSiteIdCheckpointsRoute,AuthenticatedSitesSiteIdEditRoute: AuthenticatedSitesSiteIdEditRoute,AuthenticatedSitesSiteIdIndexRoute: AuthenticatedSitesSiteIdIndexRoute
}

const AuthenticatedSitesSiteIdRouteWithChildren = AuthenticatedSitesSiteIdRoute._addFileChildren(AuthenticatedSitesSiteIdRouteChildren)



const AuthenticatedSitesRouteChildren = {
  AuthenticatedSitesSiteIdRoute: AuthenticatedSitesSiteIdRouteWithChildren,AuthenticatedSitesNewRoute: AuthenticatedSitesNewRoute,AuthenticatedSitesIndexRoute: AuthenticatedSitesIndexRoute
}

const AuthenticatedSitesRouteWithChildren = AuthenticatedSitesRoute._addFileChildren(AuthenticatedSitesRouteChildren)




const AuthenticatedTrackingRouteChildren = {
  AuthenticatedTrackingShiftIdRoute: AuthenticatedTrackingShiftIdRoute,AuthenticatedTrackingIndexRoute: AuthenticatedTrackingIndexRoute
}

const AuthenticatedTrackingRouteWithChildren = AuthenticatedTrackingRoute._addFileChildren(AuthenticatedTrackingRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedActivityRoute: AuthenticatedActivityRoute,AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedAiHelperRoute: AuthenticatedAiHelperRoute,AuthenticatedAlertsRoute: AuthenticatedAlertsRoute,AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRouteWithChildren,AuthenticatedAssignmentsRoute: AuthenticatedAssignmentsRoute,AuthenticatedBillingRoute: AuthenticatedBillingRoute,AuthenticatedClientsRoute: AuthenticatedClientsRoute,AuthenticatedContactsRoute: AuthenticatedContactsRoute,AuthenticatedCredentialsRoute: AuthenticatedCredentialsRouteWithChildren,AuthenticatedDarRoute: AuthenticatedDarRouteWithChildren,AuthenticatedDashboardsRoute: AuthenticatedDashboardsRouteWithChildren,AuthenticatedEquipmentRoute: AuthenticatedEquipmentRoute,AuthenticatedEquipmentAdminRoute: AuthenticatedEquipmentAdminRoute,AuthenticatedExportsRoute: AuthenticatedExportsRoute,AuthenticatedGeofencesRoute: AuthenticatedGeofencesRoute,AuthenticatedGuardToursRoute: AuthenticatedGuardToursRouteWithChildren,AuthenticatedHomeRoute: AuthenticatedHomeRoute,AuthenticatedIncidentsRoute: AuthenticatedIncidentsRouteWithChildren,AuthenticatedInvoicingRoute: AuthenticatedInvoicingRoute,AuthenticatedManagerRoute: AuthenticatedManagerRoute,AuthenticatedMessagesRoute: AuthenticatedMessagesRoute,AuthenticatedModulesRoute: AuthenticatedModulesRoute,AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,AuthenticatedOperationsRoute: AuthenticatedOperationsRouteWithChildren,AuthenticatedPatrolsRoute: AuthenticatedPatrolsRouteWithChildren,AuthenticatedPortalRoute: AuthenticatedPortalRoute,AuthenticatedPostOrdersRoute: AuthenticatedPostOrdersRoute,AuthenticatedRadioRoute: AuthenticatedRadioRoute,AuthenticatedReportsRoute: AuthenticatedReportsRouteWithChildren,AuthenticatedReviewRoute: AuthenticatedReviewRouteWithChildren,AuthenticatedScheduleRoute: AuthenticatedScheduleRoute,AuthenticatedSecurityRoute: AuthenticatedSecurityRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,AuthenticatedShiftReportsRoute: AuthenticatedShiftReportsRoute,AuthenticatedSiteActivityRoute: AuthenticatedSiteActivityRoute,AuthenticatedSitesRoute: AuthenticatedSitesRouteWithChildren,AuthenticatedSocRoute: AuthenticatedSocRoute,AuthenticatedSosRoute: AuthenticatedSosRoute,AuthenticatedSupervisorRoute: AuthenticatedSupervisorRoute,AuthenticatedTeamRoute: AuthenticatedTeamRoute,AuthenticatedTimeClockRoute: AuthenticatedTimeClockRoute,AuthenticatedTrackingRoute: AuthenticatedTrackingRouteWithChildren,AuthenticatedVehicleAdminRoute: AuthenticatedVehicleAdminRoute,AuthenticatedVehicleInspectionRoute: AuthenticatedVehicleInspectionRoute,AuthenticatedConsoleDispatchRoute: AuthenticatedConsoleDispatchRoute,AuthenticatedContractorPayPeriodsRoute: AuthenticatedContractorPayPeriodsRoute,AuthenticatedContractorScheduleRoute: AuthenticatedContractorScheduleRoute,AuthenticatedContractorShiftClaimRoute: AuthenticatedContractorShiftClaimRoute,AuthenticatedContractorsPartnershipIdRoute: AuthenticatedContractorsPartnershipIdRoute,AuthenticatedScanTokenRoute: AuthenticatedScanTokenRoute,AuthenticatedContractorIndexRoute: AuthenticatedContractorIndexRoute,AuthenticatedContractorsIndexRoute: AuthenticatedContractorsIndexRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRoute,CompareRoute: CompareRoute,ContactRoute: ContactRoute,CustomReportsRoute: CustomReportsRoute,DeleteAccountRoute: DeleteAccountRoute,DispatchRoute: DispatchRoute,FaqRoute: FaqRoute,ForgotPasswordRoute: ForgotPasswordRoute,HandsFreeRoute: HandsFreeRoute,ImpressumRoute: ImpressumRoute,ImprintRoute: ImprintRoute,IncidentReportingRoute: IncidentReportingRoute,InvoicingSoftwareRoute: InvoicingSoftwareRoute,LoginRoute: LoginRoute,OnboardingRoute: OnboardingRoute,PatrolRoute: PatrolRoute,PricingRoute: PricingRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,RadioPttRoute: RadioPttRoute,ResetPasswordRoute: ResetPasswordRoute,SchedulingRoute: SchedulingRoute,SecurityGuardManagementSoftwareRoute: SecurityGuardManagementSoftwareRoute,SecurityGuardSoftwareRoute: SecurityGuardSoftwareRoute,SecurityIncidentReportingSoftwareRoute: SecurityIncidentReportingSoftwareRoute,SignupRoute: SignupRoute,StartRoute: StartRoute,TemplatesRoute: TemplatesRoute,TermsRoute: TermsRoute,VoiceDarRoute: VoiceDarRoute,AcceptContractTokenRoute: AcceptContractTokenRoute,AcceptInviteTokenRoute: AcceptInviteTokenRoute,AuthCallbackRoute: AuthCallbackRoute,CheckoutReturnRoute: CheckoutReturnRoute,LeadMagnetSecurityOpsChecklistRoute: LeadMagnetSecurityOpsChecklistRoute,LeadMagnetThanksRoute: LeadMagnetThanksRoute,MarketingUnsubscribeRoute: MarketingUnsubscribeRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)